import type { ReactNode } from 'react';

import type { TerminalCopy } from '../features/links/stateCopy';

type TerminalStateProps = {
  copy: TerminalCopy;
  action?: ReactNode;
};

function defaultIcon(tone: TerminalCopy['tone']): string {
  switch (tone) {
    case 'success':
      return '✓';
    case 'danger':
      return '!';
    case 'neutral':
      return '…';
    case 'warning':
    default:
      return '⚠️';
  }
}

export function TerminalState({ copy, action }: TerminalStateProps) {
  const className = ['surface terminal', `terminal--${copy.tone}`];

  if (copy.variant) {
    className.push(`terminal--${copy.variant}`);
  }

  return (
    <section className={className.join(' ')} aria-live="polite">
      <span className="terminal__icon" aria-hidden="true">
        {copy.icon ?? defaultIcon(copy.tone)}
      </span>
      {copy.eyebrow ? <p className="eyebrow">{copy.eyebrow}</p> : null}
      <h1>{copy.title}</h1>
      <p>{copy.body}</p>
      {action ? <div className="terminal__action">{action}</div> : null}
    </section>
  );
}
